import React, { memo, useEffect, useRef, useState } from "react";

import CommercialsService from "../../services/commercials.service";
import { IProps, Title } from "../title/title";
import { CommercialsMenuItem } from "./menu/commercials-menu-item";
import { CommercialsForAllGuestsMenuItem } from "./menu/commercials-for-all-guests-menu-item";
import { SectionWrapper, } from "./menu-offer-wrapper";
import { CommericalAction, Menu, PendingBooking } from "../../types";
import { CommercialMenusCtx, useCommercialMenuItemContext } from "../../contexts/commercial-context";
import { pendingBookingStore } from "../../stores/pending-booking.store";
import { Observable, Subscription } from "rxjs";
import { addMenuToPendingBooking, removeMenuFromPendingBooking, } from "../../requests/pending-booking.requests";
import { useErrorHandler } from "react-error-boundary";
import styled from "styled-components";
const MenusBloc = styled(SectionWrapper)`
    display: inline-block;
    flex-wrap: wrap;
`;

const MenusSubBloc = styled.div`
    display: flex;
    flex-wrap: wrap;

@media screen and (max-width: 480px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`;


interface ICommercialMenusProps {
    title: IProps;
    setChildLoading: (state: boolean) => void,
}
const MenusCom = (props: ICommercialMenusProps) => {
    const commercialsService = CommercialsService;
    const [menusAvailabilities, setMenusAvailabilities] = useState<{ [key: number]: boolean }>({});
    const [action, setAction] = useState<CommericalAction | null>(null);
    const actionDetails = useRef<{ [menuId: number]: number | undefined } | undefined>(undefined);
    const { updateStatisfyMenusMandatory, } = useCommercialMenuItemContext();
    const [selectedMenusIds, setSelectedMenusIds] = useState(pendingBookingStore.selectedMenusIds)
    const throwError = useErrorHandler();
    useEffect(() => {
        setMenusAvailabilities(pendingBookingStore.menusAvailabilities);
    }, [])

    useEffect(() => {
        let subscription: Subscription | undefined = undefined;
        let observable: Observable<any> | undefined = undefined;
        if (action) {
            if (actionDetails.current !== undefined) {
                let actionDetailsValue: { [menuId: number]: number | undefined } = actionDetails.current!;
                let menuId: number = Number(Object.keys(actionDetailsValue)[0])
                let quantity: number | undefined = actionDetailsValue[menuId]
                switch (action) {
                    case "add":
                        observable = addMenuToPendingBooking(
                            menuId,
                            quantity
                        )
                        break;
                    case "remove":
                        observable = removeMenuFromPendingBooking(menuId);
                        break;
                }
                if (observable) {
                    subscription = observable.subscribe(
                        (resp: PendingBooking) => {
                            pendingBookingStore.pendingBooking = resp;
                            updateStatisfyMenusMandatory(
                                pendingBookingStore.statisfyMenusMandatory
                            );
                            setAction(null)
                            resetMenusAvailabilities();
                            setSelectedMenusIds(pendingBookingStore.selectedMenusIds);
                            props.setChildLoading(false);
                        },

                        throwError,
                        () => {
                            updateStatisfyMenusMandatory(
                                pendingBookingStore.statisfyMenusMandatory
                            );
                            props.setChildLoading(false);
                        }
                    );
                }

            }

        }
        return () => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    }, [action])

    const performAction = (action: CommericalAction, details: { [menuId: number]: number | undefined }) => {
        actionDetails.current = details;
        setAction(action);
    }
    const resetMenusAvailabilities = () => {
        setMenusAvailabilities(pendingBookingStore.menusAvailabilities)
    }
    const individualMenus = commercialsService.individualMenus.map((menu: Menu) => {
        return (
            <CommercialsMenuItem
                key={menu.id}
                menu={menu}
                setChildLoading={props.setChildLoading}
            />
        );
    });

    const forAllGuestsMenus =
        commercialsService.forAllGuestsMenus.map((menu: Menu) => {
            return (
                <CommercialsForAllGuestsMenuItem
                    key={menu.id}
                    menu={menu}
                    setChildLoading={props.setChildLoading}
                />
            );
        });
    return (
        <CommercialMenusCtx.Provider
            value={{
                resetMenusAvailabilities,
                performAction,
                selectedMenusIds,
                menusAvailabilities
            }}
        >
            <div data-test="commercials-menus">
                <Title {...props.title} />
                <MenusBloc>
                    <MenusSubBloc>
                        {individualMenus}
                    </MenusSubBloc>
                    <MenusSubBloc>
                        {forAllGuestsMenus}
                    </MenusSubBloc>

                </MenusBloc>

            </div>
        </CommercialMenusCtx.Provider>
    );
};

export const CommercialMenus = memo(MenusCom);